module.exports = __webpack_public_path__ + "img/1x.9504fd7.jpg";